import React, { useState } from "react";
import CardImg from "../../../components/CardImg";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

// Reference <Card> component (scoped style data-v-79776e43): span > img cards/{card}.png
export function RefCard({ card }) {
  return (
    <span data-v-79776e43="">
      <CardImg data-v-79776e43="" src={`${IMG}/${card}.png`} alt="" />
    </span>
  );
}

/**
 * 3 Cards Judgement video card overlay — reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > h4.text-left.text-white.text-uppercase "Cards" + div > 3 × <Card>
 * Collapsed (.hide-cards) while the first card is still "1" or after the shuffle handle is clicked.
 */
export default function ThreeCardJCardsOverlay({ cardString }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(cardString ?? "").split(",");
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={hidden ? "casino-video-cards hide-cards" : "casino-video-cards"}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <h4 className="text-left text-white text-uppercase">Cards</h4>{" "}
        <div>
          <RefCard card={cards[0]} /> <RefCard card={cards[1]} /> <RefCard card={cards[2]} />
        </div>
      </div>
    </div>
  );
}
